import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import _ from "lodash";
import MD from 'react-markdown';
import Imagelist from '../other/Imagelist';
import Video from '../other/Video';

class Project extends Component {


    render() {
        let redirect = false;
        console.log(this.props);
        const { project } = this.props;
        const { title, images, video, year, description, credits } = project;
        const vidUrl = video !== undefined ? video[0] : "";

        const imgList = images.map((o, i) => {
            const url = o.imgType === "gif" ? o.url : o.url + "&w=800"; //change width of image if you want
            return url;
        });

        return (
            redirect ?
            <Redirect to="/404" /> :
            <div className="content" id="project-page">
                <h1>{title}</h1>
                <div className="two-columns">
                    <div className="main">
                        <Video url={vidUrl} />
                        <p className="year">{year.split("-")[0]}</p>

                        <MD source={description} className="description" />
                        <Imagelist list={imgList} />
                    </div>
                    <div className="side">
                        <MD source={credits} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Project;



// WEBPACK FOOTER //
// ./src/components/Project/Project.js